import { createAction, props } from "@ngrx/store";
import { IAddDeviceToRevisionRequest, ICreateRevisionRequest, ICreateRevisionResponse, IDeleteDeviceToRevisionRequest, IGetRevisionResponse, IUpdateRevisionRequest, IUpdateRevisionResponse } from "src/app/revisions/models/revision";

// Get Revisions
export const getRevisions = createAction(
    '[Revisions] Get Revisions'
);

export const getRevisionsSuccess = createAction(
    '[Revisions] Get Revisions success', 
    props<{ revisions: IGetRevisionResponse[] }>()
);

export const getRevisionsFailure = createAction(
    '[Revisions] Get Revisions failure',
    props<{error: string}>()
);

// Get Revisions by Company
export const getRevisionsByCompany = createAction(
    '[Revisions] Get Revisions by Company ',
    props<{companyId: string}>()
);

export const getRevisionsByCompanySuccess = createAction(
    '[Revisions] Get Revisions by Company success', 
    props<{ revisions: IGetRevisionResponse[] }>()
);

export const getRevisionsByCompanyFailure = createAction(
    '[Revisions] Get Revisions by Company failure',
    props<{error: string}>()
);

// Get Revision by id
export const getRevisionById = createAction(
    '[Revisions] Get Revision by id ',
    props<{id: string}>()
);

export const getRevisionByIdSuccess = createAction(
    '[Revisions] Get Revision by id success', 
    props<{ revision: IGetRevisionResponse }>()
);

export const getRevisionByIdFailure = createAction(
    '[Revisions] Get Revision by id failure',
    props<{error: string}>()
);

// Create Revision
export const createRevision = createAction(
    '[Revisions] Create Revision',
    props<{ revision: ICreateRevisionRequest }>()
);

export const createRevisionSuccess = createAction(
    '[Revisions] Create Revision success',
    props<{ revision: ICreateRevisionResponse }>()
);

export const createRevisionFailure = createAction(
    '[Revisions] Create Revision failure',
    props<{error: string}>()
);

// Update Revision
export const updateRevision = createAction(
    '[Revisions] Update Revision',
    props<{ revision: IUpdateRevisionRequest }>()
);

export const updateRevisionSuccess = createAction(
    '[Revisions] Update Revision success',
    props<{ revision: IUpdateRevisionResponse }>()
);

export const updateRevisionFailure = createAction(
    '[Revisions] Update Revision failure',
    props<{error: string}>()
);

// Delete Revision
export const deleteRevision = createAction(
    '[Revisions] Delete Revision',
    props<{id: string}>()
);

export const deleteRevisionSuccess = createAction(
    '[Revisions] Delete Revision success',
    props<{id: string}>()
);

export const deleteRevisionFailure = createAction(
    '[Revisions] Delete Revision failure',
    props<{error: string}>()
);

// Delete Device from Revision
export const deleteDeviceFromRevision = createAction(
    '[Revisions] Delete Device from Revision',
    props<{ request: IDeleteDeviceToRevisionRequest }>()
);

export const deleteDeviceFromRevisionSuccess = createAction(
    '[Revisions] Delete Device from Revision success',
    props<{ revision: IUpdateRevisionResponse }>()
);

export const deleteDeviceFromRevisionFailure = createAction(
    '[Revisions] Delete Device from Revision failure',
    props<{ error: string }>()
);

// Complete Revision
export const completeRevision = createAction(
    '[Revisions] Complete Revision',
    props<{ id: string }>()
);

export const completeRevisionSuccess = createAction(
    '[Revisions] Complete Revision success', 
    props<{ revision: IUpdateRevisionResponse }>()
);

export const completeRevisionFailure = createAction(
    '[Revisions] Complete Revision failure',
    props<{error: string}>()
);